import { Divider, Spin } from 'antd';
import Button from 'components/Button';
import Input from 'components/Input/Input';
import ModalCommon from 'components/Input/ModalCommon';
import { NO_INTERNET } from 'components/messageError';
import Select from 'components/Select';
import { TIME_ZONE, typeCEUs } from 'helper/init.constants';
import { validateForm } from 'helper/validation';
import { useCallback, useEffect, useMemo, useState } from 'react';
import CeuServices from 'services/CeuServices';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import CourseServices from 'services/CourseServices';
import MemberService from 'services/MemberService';
import { toast } from 'sonner';

const initateForm = {
  userId: '',
  userCode: '',
  name: '',
  email: '',
  currentCEU: 0,
  awardCEU: '',
  CEUType: '',
  type: '',
  course: '',
  note: '',
};

export const statusSchedules = [
  {
    label: '受付済み',
    value: 'PAYMENT_COMPLETED',
  },
  {
    label: 'キャンセル待ち',
    value: 'CANCELLATION_WAITING_LIST',
  },
  {
    label: 'キャンセル',
    value: 'ADMIN_CANCELED',
  },
];

const AddCEUPopup = ({ isOpen, onCancel, id, onSuccess, onSuccessEdit }) => {
  const [form, setForm] = useState({ ...initateForm });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [search, setSearch] = useState('');
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [courses, setCourses] = useState([]);

  const validations = [
    {
      label: 'userId',
      value: form.userId,
      rules: [
        {
          required: true,
          message: '会員IDを入力してください。',
        },
      ],
    },
    {
      label: 'name',
      value: form.name,
      rules: [
        {
          required: true,
          message: '名前を入力してください。',
        },
      ],
    },
    {
      label: 'email',
      value: form.email,
      rules: [
        {
          required: true,
          message: 'メールアドレスを入力してください。',
        },
      ],
    },
    {
      label: 'currentCEU',
      value: form.currentCEU,
      rules: [
        {
          required: true,
          message: '現在のCEU数を入力してください。',
        },
      ],
    },
    {
      label: 'awardCEU',
      value: form.awardCEU,
      rules: [
        {
          required: true,
          message: '付与CEU数を入力してください。',
        },
        {
          regex: /^[+-]?\d+(\.\d)?$/,
          message: '有効な付与CEU数を入力してください',
        },
      ],
    },
    {
      label: 'CEUType',
      value: form.CEUType,
      rules: [
        {
          required: true,
          message: 'CEU付与種別を選択してください。',
        },
      ],
    },
    {
      label: 'type',
      value: form.type,
      rules: [
        {
          required: true,
          message: 'カテゴリーを選択してください。',
        },
      ],
    },
  ];

  const getInfo = async () => {
    setLoading(true);

    const coursesList = await getCourseList();

    CeuServices.getInfo(id)
      .then((res) => {
        if (res.isOk) {
          const prefix = res.data.subCategory?.[0] || '';
          const status = prefix === 'A' ? '新規' : '再受講';

          const courseMatch = (
            coursesList.map((i) =>
              i.excelName === 'インテグレーティッドトレーニング'
                ? {
                  value: i._id,
                  label: 'インテグレーティッド',
                }
                : {
                  value: i._id,
                  label: i.excelName,
                }
            ) || []
          )
            .map((item) => ({
              value: item.value,
              label: prefix
                ? `${prefix}.${item.label}（${status}）`
                : item.label,
            }))
            .find((c) => c.label === res.data.name);

          setForm({
            userId: res.data.user.memberId || '',
            userCode: res.data.memberId || '',
            name: res.data.user.name || '',
            email: res.data.user.email || '',
            currentCEU: res.data.user.currentCeus || 0,
            awardCEU: res.data.ceuAwarded || '',
            CEUType: res.data.grantType || '',
            type: res.data.subCategory || '',
            course: courseMatch?.value || '',
            note: res.data.note || '',
            courseName: res.data.name || '',
          });
          return res.data;
        }
        return null;
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  const handleChangeData = ({ label, value }) => {
    setErrors(errors.filter((err) => err.label !== label));
    setForm((prev) => ({
      ...prev,
      [label]: value,
    }));
  };

  const handleSetDataSearchUser = (value) => {
    setSearch(value);
  };

  const getCourseList = () => {
    setLoading(true);
    return CourseServices.getCourses()
      .then((res) => {
        if (res.isOk) {
          setCourses(res.data);
          return res.data;
        }
        return [];
      })
      .catch((err) => {
        toast.error(err?.message || err || NO_INTERNET);
        return [];
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isOpen) {
      getCourseList().then(() => {
        if (id && id !== '') {
          setTimeout(() => {
            getInfo();
          }, 100);
        }
      });
    }
  }, [isOpen, id]);

  const handleSearchUser = () => {
    if (id && id !== '') return;
    else {
      if (search === '') {
        setForm({
          name: '',
          userCode: '',
          email: '',
          userId: '',
          currentCEU: 0,
        });
        toast.error('データがありません');
        return;
      }

      setLoadingSearch(true);
      CourseScheduleRegistationServices.getInfoUser({
        search: search,
      })
        .then((res) => {
          if (
            Array.isArray(res?.data?.items) &&
            res?.data?.items.length !== 0
          ) {
            const data = {
              name: `${res?.data?.items[0].name || ''}`,
              userCode: res.data.items[0].memberId || '',
              email: res?.data?.items[0].email || '',
              userId: res.data?.items[0]._id || '',
              currentCEU: res.data.items[0].currentCeus || 0,
            };
            setForm({
              ...form,
              ...data,
            });
            setErrors(
              errors.filter(
                (error) =>
                  !['userId', 'name', 'email', 'currentCEU'].includes(
                    error.label
                  )
              )
            );
          } else {
            setForm({
              ...form,
              name: '',
              userCode: '',
              userId: '',
              email: '',
              currentCEU: 0,
            });
            toast.error('データがありません');
          }
        })
        .catch((err) => {
          toast.error(err?.message || NO_INTERNET);
        })
        .finally(() => setLoadingSearch(false));
    }
  };

   const getInfoUser = useCallback(() => MemberService.getDetailMember(form.userId)
     .then((result) => {
       console.log(result.data.status)
       return result.data.status
     })
    .catch(err => toast.error(err?.message || err || NO_INTERNET))
    , [form.userId])

  const addCEUs = async () => {
    setLoading(true);
    const status  = await getInfoUser()
    setLoading(false)
    
    CeuServices.addCEU({
      userId: form.userId,
      ceuAwarded: +form.awardCEU,
      subCategory: form.type,
      courseId: form.course,
      grantType: form.CEUType,
      note:  status !== 'Period_Extended' ? form.note : `${form.note}(延長時取得)`,
      timezone: TIME_ZONE,
    })
      .then((res) => {
        if (res.isOk) {
          toast.success('CEUの付与が正常に完了しました。');
          onCancel();
          setForm({ ...initateForm });
          setErrors([]);
          setSearch('');
          onSuccess();
        }
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  const updateCEU = () => {
    setLoading(true);
    CeuServices.updateCEU({
      id,
      body: {
        userId: form.memberId,
        ceuAwarded: +form.awardCEU,
        subCategory: form.type,
        courseId: form.course,
        grantType: form.CEUType,
        note: form.note,
        timezone: TIME_ZONE,
      },
    })
      .then((res) => {
        if (res.isOk) {
          toast.success('CEUの情報を更新しました。');
          onCancel();
          setForm({ ...initateForm });
          setErrors([]);
          setSearch('');
          onSuccessEdit();
        }
      })
      .catch((err) => toast.error(err?.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  const handleValidCourse = () => {
    if (form.type === 'A2' || form.type === 'B1') {
      if (form.course === '') {
        setErrors((errs) => [
          ...errs.filter((err) => err.label !== 'course'),
          {
            label: 'course',
            message: 'コースを選択してください。',
          },
        ]);
        return [
          ...errors.filter((err) => err.label !== 'course'),
          {
            label: 'course',
            message: 'コースを選択してください。',
          },
        ];
      } else {
        // Remove course error if course is selected
        setErrors((errs) => errs.filter((err) => err.label !== 'course'));
        return errors.filter((err) => err.label !== 'course');
      }
    } else {
      // Remove course error if not required
      setErrors((errs) => errs.filter((err) => err.label !== 'course'));
      return errors.filter((err) => err.label !== 'course');
    }
  };

  const handleCheckAwardCEU = () => {
    const errs = [];

    // Check if awardCEU is empty or invalid
    if (form.awardCEU === '' || form.awardCEU === null || form.awardCEU === undefined) {
      return errs; // Let the required validation handle empty values
    }

    const awardCEU = Number(form.awardCEU);
    const currentCEU = Number(form.currentCEU);

    if (isNaN(awardCEU)) {
      errs.push({
        label: 'awardCEU',
        message: '有効な付与CEU数を入力してください',
      });
    } else if (!isNaN(currentCEU) && awardCEU + currentCEU < 0) {
      errs.push({
        label: 'awardCEU',
        message: '現在のCEU数を超えるCEU数のマイナスはできません',
      });
    }

    setErrors((prevErrors) => {
      // Remove old awardCEU errors
      const filtered = prevErrors.filter((err) => err.label !== 'awardCEU');
      return [...filtered, ...errs];
    });

    return errs;
  };

  const handleAddCEUs = () => {
    const isValid = validateForm(form, validations);
    const isValidCourse = handleValidCourse();
    const isValidCheckCEUAward = handleCheckAwardCEU() || [];

    setErrors([...isValid, ...isValidCheckCEUAward, ...isValidCourse]);

    if (
      isValid.length === 0 &&
      isValidCourse?.length === 0 &&
      isValidCheckCEUAward.length === 0
    ) {
      addCEUs();
    }
  };

  const handleUpdateCEUs = () => {
    const isValid = validateForm(form, validations, (errs) => setErrors(errs));
    const isValidCourse = handleValidCourse();

    isValid.length === 0 && isValidCourse && updateCEU();
  };

  const handleFieldErrorChange = (label, message) => {
    setErrors((prevErrors) => {
      const existingIndex = prevErrors.findIndex((err) => err.label === label);
      if (message) {
        if (existingIndex !== -1) {
          const newErrors = [...prevErrors];
          newErrors[existingIndex] = { label, message };
          return newErrors;
        } else {
          return [...prevErrors, { label, message }];
        }
      } else {
        if (existingIndex !== -1) {
          const newErrors = [...prevErrors];
          newErrors.splice(existingIndex, 1);
          return newErrors;
        }
        return prevErrors;
      }
    });
  };

  const swapLastTwoImmutable = (arr) => {
    if (!Array.isArray(arr) || arr.length < 2) return arr;

    return [...arr.slice(0, -2), arr[arr.length - 1], arr[arr.length - 2]];
  };

  const courseOptions = useMemo(
    () =>
      (swapLastTwoImmutable(courses) || []).map((i) =>
        i.excelName === 'インテグレーティッドトレーニング'
          ? {
            value: i._id,
            label: 'インテグレーティ',
          }
          : { value: i._id, label: i.excelName }
      ),
    [courses]
  );

  return (
    <div>
      <Spin spinning={loading}>
        <ModalCommon
          onAfterOpen={() => { }}
          title={id ? '編集' : '新規追加'}
          $padding={[24, 24, 24, 24]}
          open={isOpen}
          onCancel={() => {
            onCancel();
            setForm({ ...initateForm });
            setErrors([]);
            setSearch('');
          }}
          width={600}
          heightHeader={56}
          footer={
            <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
              <Button
                btnType="back"
                onClick={() => {
                  onCancel();
                  setForm({ ...initateForm });
                  setErrors([]);
                  setSearch('');
                }}
                fontSize={14}
                height={40}
                width={120}
              >
                キャンセル
              </Button>
              <Button
                type="primary"
                onClick={id && id !== '' ? handleUpdateCEUs : handleAddCEUs}
                fontSize={14}
                height={40}
                width={120}
                loading={loading}
              >
                <p style={{ letterSpacing: '0' }}>追加</p>
              </Button>
            </div>
          }
        >
          {!id && (
            <div className="flex w-full items-center justify-between">
              <Input
                placeholder={'名前、メールアドレス、会員ID'}
                width={400}
                height={40}
                value={search}
                onChange={(e) => handleSetDataSearchUser(e)}
              />
              <Button
                width={84}
                height={40}
                btnType="outline"
                onClick={handleSearchUser}
                loading={loadingSearch}
              >
                <p style={{ letterSpacing: '0' }}>検索</p>
              </Button>
            </div>
          )}

          {!id && <Divider className="m-0" />}
          <Input
            title="userId"
            label="会員ID"
            format="memberId"
            disabled
            $autoTrim={true}
            errors={errors}
            rules={[
              {
                required: true,
                message: '会員IDを入力してください。',
              },
            ]}
            widthInput={400}
            heightInput={38}
            widthLabel={136}
            value={form.userCode || form.userId}
            $paddingMessage={152}
          />

          <Input
            title="name"
            label="名前"
            disabled
            $autoTrim={true}
            widthInput={400}
            heightInput={38}
            errors={errors}
            widthLabel={136}
            value={form.name}
            $paddingMessage={152}
          />
          <Input
            title="email"
            label="メールアドレス"
            disabled
            $autoTrim={true}
            errors={errors}
            widthInput={400}
            heightInput={38}
            widthLabel={136}
            value={form.email}
            $paddingMessage={152}
          />

          <Input
            title="currentCEU"
            label="現在のCEU数"
            disabled
            $autoTrim={true}
            errors={errors}
            widthInput={400}
            heightInput={38}
            widthLabel={136}
            value={form.currentCEU}
            $paddingMessage={152}
          />

          <Input
            title="awardCEU"
            label="付与CEU数"
            required
            $autoTrim={false}
            disabled={id && id !== ''}
            rules={[
              { required: true, message: '付与CEU数を入力してください。' },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  if (!/^[+-]?\d+(\.\d)?$/.test(value))
                    return Promise.reject('有効な付与CEU数を入力してください');
                  if (value === '')
                    return Promise.reject('有効な付与CEU数を入力してください');
                },
                validateTrigger: 'onChange',
              },
            ]}
            onErrorChange={handleFieldErrorChange}
            widthInput={400}
            heightInput={40}
            widthLabel={136}
            errors={errors}
            value={form.awardCEU}
            onChange={(e) => handleChangeData({ label: 'awardCEU', value: e })}
            $paddingMessage={152}
          />

          <Select
            title="CEUType"
            label="CEU付与種別"
            required
            placeholder="個別付与 / 審査申請 / 修正付与"
            $autoTrim={false}
            rules={[{ required: true, message: '名前を入力してください' }]}
            widthSelect={400}
            heightSelect={40}
            widthLabel={136}
            errors={errors}
            options={[
              {
                value: 'QR',
                label: 'QR付与',
              },
              { value: 'BATCH', label: '一括付与' },
              { value: 'INDIVIDUAL', label: '個別付与' },
              { value: 'REVIEW_APPLICATION', label: '審査申請' },
              { value: 'CORRECTION', label: '修正付与' },
            ]}
            showOptions={['INDIVIDUAL', 'REVIEW_APPLICATION', 'CORRECTION']}
            classNameSelect={`!rounded-[10px]`}
            value={form.CEUType}
            onChange={(e) =>
              handleChangeData({ label: 'CEUType', value: e.value })
            }
            $paddingMessage={152}
          />

          <Select
            title="type"
            label="カテゴリー"
            required
            $autoTrim={false}
            rules={[{ required: true, message: '名前を入力してください' }]}
            widthSelect={400}
            heightSelect={40}
            widthLabel={136}
            errors={errors}
            options={typeCEUs}
            value={form.type}
            onChange={(e) =>
              handleChangeData({ label: 'type', value: e.value })
            }
            $paddingMessage={152}
          />

          {(form.type === 'A2' || form.type === 'B1') && (
            <Select
              title="course"
              label="コース"
              required
              $autoTrim={false}
              rules={[{ required: true, message: '名前を入力してください' }]}
              widthSelect={400}
              heightSelect={40}
              widthLabel={136}
              errors={errors}
              options={courseOptions}
              value={form.course}
              onChange={(e) =>
                handleChangeData({ label: 'course', value: e.value })
              }
              $paddingMessage={152}
            />
          )}

          <Input
            title="note"
            label="メモ"
            $autoTrim={true}
            errors={errors}
            widthInput={400}
            heightInput={38}
            widthLabel={136}
            value={form.note}
            onChange={(e) => handleChangeData({ label: 'note', value: e })}
            $paddingMessage={152}
          />
        </ModalCommon>
      </Spin>
    </div>
  );
};

export default AddCEUPopup;
